(function () {
  'use strict';

  /*
   * jb-beforeafter.js - Jarri Boottii before/after comparison slider
   *
   * ~2 KB, no library. One pointer handler per stage.
   *
   * How it works
   * ------------
   * The divider position is a single CSS custom property, --jb-ba-pos, on the
   * stage. CSS does everything else: the AFTER layer is clipped with
   * clip-path: inset(0 calc(100% - var(--jb-ba-pos)) 0 0), and the divider and
   * handle are positioned at left: var(--jb-ba-pos). So a drag writes one
   * value and the browser composites the rest - no per-frame layout.
   *
   * Because the position is set inline in Liquid at 50%, the slider is already
   * correct on first paint. This script only adds interactivity; if it never
   * ran, the section would still render as a clean 50/50 comparison.
   *
   * Direction
   * ---------
   * pos = 0%   -> all AFTER    pos = 100% -> all BEFORE
   * The BEFORE layer occupies the LEFT of the divider, AFTER the RIGHT, which
   * is what the on-image labels say.
   *
   * Input support
   * -------------
   * Pointer Events when available (covers mouse, touch and pen in one path on
   * Chrome, Safari 13+, iOS and Android), with a mouse/touch fallback for
   * anything older. Tap or click anywhere on the stage jumps the divider there.
   * Arrow keys / Home / End move it from the keyboard.
   */

  if (window.__jbBeforeAfter) return;
  window.__jbBeforeAfter = true;

  var hasPointer = typeof window.PointerEvent === 'function';

  function clamp(n) {
    return n < 0 ? 0 : n > 100 ? 100 : n;
  }

  function setup(stage) {
    if (!stage || stage.__jbBaReady) return;
    stage.__jbBaReady = true;

    var handle = stage.querySelector('[data-jb-ba-handle]');
    var pos = 50;
    var dragging = false;

    function apply(next, announce) {
      pos = clamp(next);
      stage.style.setProperty('--jb-ba-pos', pos + '%');
      if (handle) {
        var rounded = Math.round(pos);
        handle.setAttribute('aria-valuenow', rounded);
        if (announce) {
          handle.setAttribute(
            'aria-valuetext',
            rounded + '% before, ' + (100 - rounded) + '% after'
          );
        }
      }
    }

    function fromClientX(x) {
      var r = stage.getBoundingClientRect();
      if (!r.width) return pos;
      return ((x - r.left) / r.width) * 100;
    }

    /* ---------------- pointer / mouse / touch ---------------- */

    function start(x, e) {
      dragging = true;
      stage.setAttribute('data-jb-ba-dragging', 'true');
      apply(fromClientX(x), false);
      if (e && e.cancelable) e.preventDefault();
    }

    function move(x, e) {
      if (!dragging) return;
      apply(fromClientX(x), false);
      /* Stop the page from scrolling sideways or selecting text mid-drag. */
      if (e && e.cancelable) e.preventDefault();
    }

    function end() {
      if (!dragging) return;
      dragging = false;
      stage.removeAttribute('data-jb-ba-dragging');
      apply(pos, true);
    }

    if (hasPointer) {
      stage.addEventListener('pointerdown', function (e) {
        if (e.button != null && e.button !== 0) return;
        start(e.clientX, e);
        /* Capture so the drag keeps tracking even off the element. */
        try {
          if (e.pointerId != null) stage.setPointerCapture(e.pointerId);
        } catch (err) {}
      });

      stage.addEventListener('pointermove', function (e) {
        move(e.clientX, e);
      });

      stage.addEventListener('pointerup', end);
      stage.addEventListener('pointercancel', end);
      stage.addEventListener('lostpointercapture', end);
    } else {
      stage.addEventListener('mousedown', function (e) { start(e.clientX, e); });
      document.addEventListener('mousemove', function (e) { move(e.clientX, e); });
      document.addEventListener('mouseup', end);

      stage.addEventListener(
        'touchstart',
        function (e) { if (e.touches[0]) start(e.touches[0].clientX, e); },
        { passive: false }
      );
      stage.addEventListener(
        'touchmove',
        function (e) { if (e.touches[0]) move(e.touches[0].clientX, e); },
        { passive: false }
      );
      stage.addEventListener('touchend', end);
      stage.addEventListener('touchcancel', end);
    }

    /* Never let the browser start a native image drag from inside the stage. */
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* ---------------- keyboard ---------------- */

    if (handle) {
      handle.addEventListener('keydown', function (e) {
        var step = e.shiftKey ? 10 : 2;
        var next = null;

        if (e.key === 'ArrowLeft' || e.key === 'Left') next = pos - step;
        else if (e.key === 'ArrowRight' || e.key === 'Right') next = pos + step;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = 100;

        if (next === null) return;
        e.preventDefault();
        apply(next, true);
      });

      /* The handle is a <button>; stop a click on it from also being treated
         as a "jump to this point" tap. */
      handle.addEventListener('click', function (e) { e.preventDefault(); });
    }

    apply(50, true);
  }

  function init() {
    var stages = document.querySelectorAll('[data-jb-ba]');
    for (var i = 0; i < stages.length; i++) setup(stages[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor re-renders sections; pick up any new stage without touching
     Shopify's own editor scripts. */
  document.addEventListener('shopify:section:load', init);
})();
